<template>
  <div class="Search">
      <div class="search-content clear">
            <div class="search-request clear" v-if="getCourseByKeyApi.key">
                <div class="float-left border">关键词：{{getCourseByKeyApi.key}} <i class="icon-del" @click="delkey"></i></div>
                <p class="float-left">共找到<span>{{rowCount}}</span>门<span>“{{getCourseByKeyApi.key}}”</span>相关课程</p>
            </div>
            <!-- 搜索结果 -->
            <!-- <div class="search-nav">
                <span>全部报告 </span> <template>> <span v-if="title">{{title}}</span><span v-if="getCourseByKeyApi.catecode !== ''">{{catename}}</span></template>
            </div> -->
            <!-- 搜索导航 -->

            <div class="search-class">
                <div class="big-class item">
                    <p class="name">行业大类：</p>
                    <div class="msg">
                        <span :class="{active: getCourseByKeyApi.catecode == ''}" @click="tabCatecode('')">全部</span>
                        <span v-for="(item,index) in reportType" :key="index" :class="{active: getCourseByKeyApi.catecode == item.code}" @click="tabCatecode(item.code)">{{item.name}}</span>
                    </div>
                </div>
                <div class="small-class item" v-if="getCourseByKeyApi.catecode !== ''">
                    <p class="name">行业小类：</p>
                    <div class="msg">
                        <div><span :class="{active: getCourseByKeyApi.catecode2 == ''}" @click="tabCatecode2('')">全部</span></div>
                        <div v-for="(item,index) in reportType" :key="index">
                            <template v-if="getCourseByKeyApi.catecode !== ''">
                                <template v-if="item.code == getCourseByKeyApi.catecode">
                                    <span v-for="(items,indexs) in item.content" :key="indexs" :class="{active: getCourseByKeyApi.catecode2 == items.code}" @click="tabCatecode2(items.code)">{{items.name}}</span>
                                </template>
                            </template>
                            <!-- <template v-else>
                                <span v-for="(items,indexs) in item.content" :key="indexs" :class="{active: getCourseByKeyApi.catecode2 == items.code}" @click="tabCatecode2(items.code)">{{items.name}}</span>
                            </template> -->
                        </div>
                    </div>
                </div>
                <div class="type item">
                    <p class="name">课程价格：</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in bgtype" :key="indexs" :class="{active: getCourseByKeyApi.feetype == items.code}" @click="tabFeetype(items.code)">{{items.name}}</span>
                    </div>
                </div>
                <div class="year item">
                    <p class="name">课程类型：</p>
                    <div class="msg">
                        <span v-for="(items,indexs) in bgYear" :key="indexs" :class="{active: getCourseByKeyApi.coursetype == items.code}" @click="tabcoursetype(items.code)">{{items.name}}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="coupon_msg" v-if="preferContent">
                平台优惠：以下课程可使用"<span>{{prefercontent}}</span>"
            </div> -->
            <div class="search-main">

                <div class="null" v-if="courselist.length === 0">
                    <img src="~common/images/search/search-null.png" alt="searchnull">
                    当前暂无课程
                </div>

                <div class="search-list clear" v-if="courselist.length > 0">
                    <StandardCourseCard v-for='(item, index) in courselist' :key='index' :data='item'></StandardCourseCard>
                </div>           
            </div>
            <!-- 搜索主体 -->

            <el-pagination background layout="prev, pager, next" :page-size="getCourseByKeyApi.pageSize" :current-page="getCourseByKeyApi.page" :total="rowCount" v-if="courselist.length > 0" @current-change="handleCurrentChange"></el-pagination>
            <!-- 分页 -->

            
      </div>
  </div>
</template>

<script>
import $ from 'jquery'
import {mapActions, mapGetters} from 'vuex'
import types from './components/CourseSearchType.json' // 分类
import {getSearchResult} from 'api/reportApi'
// searchByKey, 
import StandardCourseCard from '../../pc/components/standardCourseCardTwo.vue'
export default {
    // metaInfo: {
    //     title: '这是标题', // set a title
    //     meta: [{                 // set meta
    //         name: 'keyWords',
    //         content: '这是关键字'
    //     }]
    // //   link: [{                 // set link
    // //     rel: 'asstes',
    // //     href: 'https://assets-cdn.github.com/'
    // //   }]
    // },
    name: "Search",
    data() {
        return {
            reportType: [], // 报告分类
            bgtype: [{name:"全部", code: ""},{name:"免费", code: "1"},{name:"付费", code: "2"},{name:"会员", code: "3"}], // 报告类型
            bgYear: [{name:"全部", code: ""},{name:"单课", code: "1"},{name:"系列课 ", code: "2"}], // 报告年份

            getCategoryByKeyData: {}, // 课程分类集合
            courselist: [], // 课程列表
            keyType: 0,    // 课程类别关键词选中下标
            getCourseByKeyApi: {
                key: this.$route.query.data ? decodeURI(this.$route.query.data) : '',   // 搜索关键词
                catecode: this.$route.query.catecode ? this.$route.query.catecode : '',   // 行业大类code
                catecode2: this.$route.query.typeData ? this.$route.query.typeData : '', // 行业小类code
                coursetype: '', // 课程类型
                feetype: this.$route.query.feetype ? this.$route.query.feetype : '', // 资费类型 1免费 2收费
                kmctype: 7,  // 媒资类型 2报告 7课程  8 题库
                page: 1,   // 页码
                pageSize: 30,   // 每页记录数
                couponinnerid: this.$route.query.couponinnerid ? this.$route.query.couponinnerid : '',
                voucherdistype: this.$route.query.voucherdistype ? this.$route.query.voucherdistype : ''
            },
            clickcotecode: this.$route.query.catecode ? this.$route.query.catecode : '',  // 选中的类型
            catename: '',  // 分类名称
            rowCount: 0,
            title: this.$route.query.title,
            // prefercontent: ''
        }
    },
    created() {
        if(this.domainInfo.isMobile){
            let routerQuery = {
                searchtype: 1,
                catecode: this.$route.query.catecode,
                feetype: this.$route.query.feetype

            }
            if (this.$route.query.isMobile && this.$route.query.isMobile == 1) {
                routerQuery.key =  this.$route.query.data ? this.$route.query.data: ''
            } else {
                routerQuery.key =  this.$route.query.data ? encodeURI(this.$route.query.data): ''
            }

            this.$router.push({
                name: 'MSearchList',
                query: routerQuery
            })
        }
    },
    mounted() {
        this.reportType = types

        // 回到定点
        this._clearScrollTop()
        // if (!this.$route.query.data) {
        //    this.key = ''
        // } 
        if (this.getCourseByKeyApi.catecode2 && this.getCourseByKeyApi.catecode2.length > 0) {
            this.clickcotecode = this.getCourseByKeyApi.catecode2
        }
        this.getSearchResult(1)

    },
    methods: {
        getSearchResult(page) { // 获取课程列表
            this._clearScrollTop()
            this.getCourseByKeyApi.page = page
            this.setLoading(true)

            let result = JSON.parse(JSON.stringify(this.getCourseByKeyApi))
            result.catecode = this.clickcotecode
            result.catecode2 = ''
            if (result.feetype === '3') {
                result.feetype = ''
                result.zjmemtype = 1
            }
            
            getSearchResult({
                data: result,
                success: data => {
                    this.setLoading(false)
                    this.courselist = data.data.courselist
                    this.rowCount = data.data.pageinfo.rowCount
                    // if (data.data.pageinfo.pageNum === 1) {
                    //     this.prefercontent = data.data.prefercontent
                    // }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        tabCatecode(code) {
            this.getCourseByKeyApi.catecode = code 
            this.getCourseByKeyApi.catecode2 = ''
            this.clickcotecode = code
            this.getSearchResult(1)
        },
        tabCatecode2(code) {
            this.getCourseByKeyApi.catecode2 = code 
            this.clickcotecode = code
            this.getSearchResult(1)
        },
        tabFeetype(code) {
            this.getCourseByKeyApi.feetype = code
            this.getSearchResult(1)
        },
        tabcoursetype(code) {
            this.getCourseByKeyApi.coursetype = code
            this.getSearchResult(1)
        },
        handleCurrentChange(val) { // 页数发生变化时触发

            // this.getCourseByKeyApi.page = val

            // 页数发生变化，取得列表
            this.getSearchResult(val)

        },
        delkey() { // 清空选中关键词
            this.$router.push({name: 'Search'})
        },
        _clearScrollTop() { // 初始化滚动条高度
            this.$nextTick(() => {
                $('html').scrollTop(0)
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        $route: {
            handler (val) { // val 更新的, oldVal 过去的

                this.getCourseByKeyApi.key = val.query.data
                this.getSearchResult(1)

            },
            // 深度观察监听
            deep: true
        }
    },
    computed: {
        ...mapGetters(
            ['domainlist','domainInfo']
        )
    },
    components: {
        StandardCourseCard
    }
}
</script>

<style lang="scss" type="text/scss" >
.Search {
    // .standardCourseCard .title {
    //     font-size: 14px;
    // }
    // margin-top: 80px;
    .el-menu {
        margin-bottom: 31px;
        .el-menu-item {
            font-size: 18px;
        }
        .el-menu-item.is-active {
            color: #409EFF !important;
        }
    }

    .null {
        margin-top: 120px;
        margin-bottom: 180px;
        text-align: center;
        color: #CADAEE;
        font-size: 18px;

        img {
            margin: auto;
            margin-bottom: 26px;
            width: 234px;
            height: 121px;
        }
    }
    .icon-del {
        display: inline-block;
        width: 10px;
        height: 10px;
        cursor: pointer;
        background: url('../../../common/images/search/del.png');
        background-size: 10px;
    }
    .search-content {
        margin: auto;
        padding-top: 30px;
        width: 1180px;

        .search-request {
            margin-bottom: 20px;
            .border {
                padding: 0 8px;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                border: dashed  1px #409EFF;
            }
            p {
                margin-left: 30px;
                line-height: 28px;
                font-size: 14px;

                span {
                    display: inline-block;
                    padding:  0 5px;
                    color: #409EFF
                }
            }
        }

        

        .search-class {
            margin-top: 0;
            padding: 0 20px;
            overflow: hidden;
            background:rgba(255,255,255,1);
            border: solid 1px #eee;
            // box-shadow:0px 0px 6px 0px rgba(0,0,0,0.2);

            .item {
                padding-top: 20px;
                // border-bottom: solid 1px #E5E5E5;
                overflow: hidden;
                &~.item {
                    border-top: solid 1px #eee;
                }
            }
            .name {
                float: left;
                display: block;
                width: 83px;
            }    
            .msg {
                float: left;
                width: calc(100% - 83px);
            }

            span {
                float: left;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                margin-bottom: 15px;
                font-size: 12px;
                margin-left: 30px;
                cursor: pointer;

                &.active {
                    font-size: 12px;
                    padding: 0 7px;
                    color: #fff;
                    background:#409EFF;
                    border-radius:10px;
                }
            }
        }
        // .coupon_msg {
        //     background: #F7F7F7;
        //     padding: 10px 0;
        //     margin-top: 10px;
        //     text-align: center;
        //     font-size: 14px;
        //     span {
        //         color: #EC5E69;
        //     }
        // }
        .search-main {
            margin-top: 20px;
            .search-list {
                margin: 0 -20px 0 0;
            }
        }
        
        .el-pagination {
            margin-top: 20px;
            text-align: center;
            margin-bottom: 20px;
        }
    }
}
</style>